// src/components/Home.tsx

import React from "react";
import "./Home.css";

const Home: React.FC = () => {
  return (
    <main className="home-content">
      <h1>Welcome to DriveTest Prep</h1>
      <p>
        Prepare for your driving theory tests with ease using our comprehensive quiz app. Whether
        you're gearing up for the Basic Theory Test (BTT), Riding Theory Test (RTT), or Final Theory
        Test (FTT), our app provides all the tools you need to succeed.
      </p>
      <ul>
        <li>Offline Access: Study anytime, anywhere without internet.</li>
        <li>Ad-Free Experience: Focus on learning without interruptions.</li>
        <li>Progress Tracking: Monitor your improvement over time.</li>
        <li>Error Review: Persist and review your wrong answers.</li>
        <li>Mock Tests: Simulate real test conditions with evaluation mode.</li>
        <li>Grind Mode: Access all questions for unlimited practice.</li>
      </ul>
    </main>
  );
};

export default Home;
